import { Injectable } from '@angular/core';
import { PageService } from './page.service';
import { StoreService } from '../../services/store/store.service';
import { NavController } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class RedirectService {
	constructor(private store: StoreService, private page: PageService,private navCtrl: NavController) {}

	async checkRedirect(redirectMethodChekerList: Array<() => Promise<boolean>>) {
		let isRedirected = false;
		for (const redirectMethodChecker of redirectMethodChekerList) {
			isRedirected = await Promise.resolve(redirectMethodChecker());
			if (isRedirected) {
				return;
			}
		}
	}

	goToLoggedArea() {
		this.page.goToLoggedArea();
	}

	goToHome() {
		this.page.goToHome();
	}

	logout() {
		this.store.deleteUserLogged();
		//this.page.gotToLogin();
		this.navCtrl.navigateForward('home').then();
	}
}
